import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';


export interface ITOCProps {
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
}

class TOCItem extends React.Component<ITOCProps> {

  render() {
    if (this.props.connectDragSource == undefined) {
      return(<div></div>);
    }

    const isDragging = (this.props.isDragging != undefined) ? this.props.isDragging : false;
    const className = `divider-box-title TOC-item ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(isDragging);
    return this.props.connectDragSource(
      <span className={className}>Table of Contents</span>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      type: placeholderTypes.TOC,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(TOCItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/TableOfContentItem.tsx